// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imagecontainer {\n  position: relative;\n}\n.imagecontainer img {\n  display: block;\n}\n.imagecontainer .copy {\n  position: absolute;\n  top: 0;\n  right: 10px;\n}\n.imagecontainer .text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.modal-height-width {\n  width: 100vw !important;\n}\n\n.fixTableHead {\n  overflow-y: auto;\n  height: 50px;\n}\n\n.fixTableHead-th th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n", ""]);
// Exports
module.exports = exports;
